import React from "react";

const ModalButton = ({ children }) => {
  return <div className="modal-buttons">{children}</div>;
};

export default ModalButton;
